import isNode from 'utils/environment';
import { ENGLISH, ENGLISH_USA } from 'config/types/language';

export const checkUsEnglish = (fallbackLanguage) => {
  if (isNode()) {
    return fallbackLanguage;
  }

  switch (fallbackLanguage) {
    case ENGLISH:
    case ENGLISH_USA:
      return 'en-US' === window.navigator.language ?
        ENGLISH_USA : ENGLISH;

    default:
      return fallbackLanguage;
  }
};

export default checkUsEnglish;
